<template>
  <div class="content">
    <PageHeader title="Terms and Conditions"></PageHeader>
    <h3>FANHIVE COMPETITION PLATFORM - TERMS AND CONDITIONS FOR USERS</h3>
    <v-card
      outlined
      class="mb-4 vcardcontent"
    >
      <v-card-text style="color:#ffffff;" class="honeyBold">
        <p>
          <b>1.</b> These Terms
        </p>
        <p>
          1.1 These are the Terms and Conditions on which we supply you with use of our website and, if you register as a User, access to the Competitions either run by us or run by different sports clubs and all hosted on our Platform (all capitalised words are defined in paragraph 19 below).
        </p>
        <p>
          1.2 Please read these Terms and Conditions carefully as they will form part of the contract between you and Fanhive once Fanhive sends you an email accepting you as a User on the Platform.
        </p>
        <p>
          <b>2.</b> Who we are
        </p>
        <p>
          Fanhive Limited is a company incorporated in England and Wales with company registration number 13781356 and registered address at 1 Sundorne Avenue, Shrewsbury, SY1 4JW, United Kingdom ("Fanhive") and has developed the Fanhive Platform through which a sports club can host Competitions and you, the User, can pay to participate in these Competitions.
        </p>
        <p>
          <b>3.</b> Our contract with you
        </p>
        <p>
          3.1 Our acceptance of your application to be a User on our Platform will take place when we email you a Welcome email after your acknowledgement of these terms and conditions, at which point a contract will come into existence between you and us.
        </p>
        <p>
          3.2 The contract between you and Fanhive will include the details set out in:
        </p>
        <p class="indent"><b>3.2.1</b> your application to register as a User on the Platform;</p>
        <p class="indent"><b>3.2.2</b> these Terms and Conditions; and</p>
        <p class="indent"><b>3.2.3</b> the Defined Terms in Clause 19 of these Terms and Conditions.  </p>
        <p>
          3.3 If you enter a competition through our Platform, it is on the basis that these Terms and Conditions are accepted. They govern Fanhive's relationship with you as a competition Entrant.  
        </p>
        <p>
          3.4 Please note that, as a consumer, you have a right to end the contract with us if you change your mind about wanting to be a User of our Platform.  If you do change your mind please notify us at support@fanhive.co.uk notifying us of your wish to terminate the contract.  You may also close the account within your profile on the platform.
        </p>
        <p>
          3.5 Fanhive reserves the right to alter these Terms and Conditions at any time. Where a material change is made, you will be notified through the e-mail associated with your registered account. What constitutes a material change shall be determined by Us in our sole discretion, acting reasonably.
        </p>
        <p>
          <b>4.</b> Please Note that:
        </p>
        <p>
          4.1 Fanhive does not offer competitions in any jurisdiction where such competitions are unlawful.
        </p>
        <p>
          4.2 It is your responsibility to ensure that you are not located in a jurisdiction where it is unlawful for you to enter, or participate, in such competitions.
        </p>
        <p>
          4.3 If we are unable to accept your application to be a User on our Platform, we will inform you of this by email.
        </p>
        <p>
          <b>5.</b> The Competitions hosted on our Platform
        </p>
        <p>
          5.1 The competitions hosted on our Platform are all "Player of the Match" competitions. 
        </p>
        <p>
          5.2 Each competition relates to a sports match for a team of the Club Host or Fanhive's choice and will involve you, as an Entrant, answering a series of questions prior to a match and voting for the player of the match following the match.  
        </p>
        <p>
          5.3 In any competition there will be two Winners (an Entrant and the Player of the Match).
        </p>
        <p>
          5.4 The results of the Player of the Match vote will be posted on the “Past Winners” page on our Platform following the vote as well as the Winner of the competition will be announced on the “Past Winners” page on the Platform.
        </p>
        <p>
          5.5 Each Winner will receive a Prize.  The organiser of each competition, whether it is Fanhive or a Club Host, will determine what reward, if any, the Player of the Match will receive.
        </p>
        <p>
          <b>6.</b> Eligibility
        </p>
        <p>
          6.1 The competition is open to all residents in the UK or internationally (if an entry would be lawful in the Entrant's country of residence) and all Entrants must be aged 18 years or over, except:
        </p>
        <p class="indent"><b>6.1.1</b> employees of Fanhive or the Club Host or their holding or subsidiary companies;</p>
        <p class="indent"><b>6.1.2</b> employees of agents or suppliers of Fanhive or its holding or subsidiary companies, who are professionally connected with the competition or its administration; or</p>
        <p class="indent"><b>6.1.3</b> members of the immediate families or households of those categories in paragraphs 6.1.1 and 6.1.2 above; or</p>
        <p class="indent"><b>6.1.4</b> players who are participating in the relevant competition match.</p>
        <p>
          6.2 By entering the competition, an Entrant confirms that they are eligible to do so and eligible to claim the prize that they might win. Fanhive may require an Entrant to provide proof that they are eligible to enter the competition.
        </p>
        <p>
          6.3 Fanhive will not accept competition entries that are:
        </p>
        <p class="indent"><b>6.3.1</b> automatically generated by computer;</p>
        <p class="indent"><b>6.3.2</b> completed by third parties or in bulk; or</p>
        <p class="indent"><b>6.3.3</b> incomplete.</p>
        <p>
          6.4 Entries on behalf of another person will not be accepted and joint submissions are not allowed.
        </p>
        <p>
          6.5 Fanhive reserves all rights to disqualify an Entrant or Winner if their conduct is contrary to the spirit or intention of the prize competition.
        </p>
        <p>
          6.6 Only registered Users of Fanhive are eligible to enter competitions hosted on our Platform.
        </p>
        <p>
          <b>7.</b> How to enter a Competition
        </p>
        <p>
          7.1 Each competition will run from the Opening Date and Time to the Closing Date and Time inclusive. The timings for each competition will commence prior to the start of the match that is the subject of the competition and end after the end of the match, inclusive. 
        </p>
        <p>
          7.2 All competition entries must be received by Fanhive by no later than Closing Time on the Closing Date.  All competition entries received after the Closing Date and Time are automatically disqualified.  If a competition states that there are a maximum number of Entrants to the competition, then the competition will close on the earlier of (a) the maximum number of Entrants being reached and (b) the Closing Date and Time.
        </p>
        <p>
          7.3 To enter a Player of the Match competition you must:
        </p>
        <p class="indent"><b>7.3.1</b> create an online account on the Platform;</p>
        <p class="indent"><b>7.3.2</b> select your desired competition;</p>
        <p class="indent"><b>7.3.3</b> pay the Entry Price for the Entry using registered card payment details.  Once an Entry is submitted, the card used for the transaction will be electronically approved through our payment service provider;</p>
        <p class="indent"><b>7.3.4</b> submit your answers to the relevant Competition Entry Question(s) for that competition by the Closing Date and Time; and</p>
        <p class="indent"><b>7.3.5</b> select the Player of the Match when prompted by Fanhive after the relevant match.</p>
        <p>
          7.4 Entering a Player of the Match competition is not dependent on answering the Competition Entry Question(s) correctly and Entrants are entered no matter which answers were selected by the Entrant. However, only entries that contain the correct answers to the Competition Entry Questions, and have selected the winning Player of the Match will be entered into the final draw for the relevant competition. 
        </p>
        <p>
          7.5 If the time runs out or the questions are not all answered, the Entrant is given another chance to answer a new set of questions.
        </p>
        <p>
          7.6 By submitting a competition entry, you are agreeing to be bound by these Terms and Conditions.
        </p>
        <p>
          7.7 For help with entries, please contact support@fanhive.co.uk .
        </p>
        <p>
          7.8 Users may enter a competition multiple times each with different sets of Competition Entry Questions and this way can increase their chances of winning a Prize, provided that they select the winning Player of the Match. 
        </p>
        <p>
          7.9 All entries to competitions are final and no refunds shall be made for any reason, except in the case where Fanhive and/or the Sport Club Host cancels the competition. 
        </p>
        <p>
          <b>8.</b> Winners
        </p>
        <p>
          8.1 Each entry that contains the correct answer(s) to the respective Competition Entry Question(s) will be entered into the draw for that respective competition.
        </p>
        <p>
          8.2 After the relevant match Closing Time, Entrants will be asked by Fanhive to select the Player of the Match.
        </p>
        <p>
          8.3 After the Player of the Match competition closing time, Fanhive will determine the Player of the Match based on the player with the most Entrant selections (votes). Entrants who do not select a Player of the Match before the competition closing time will forfeit their entry(ies).
        </p>
        <p>
          8.4 The Winner will be selected randomly by Fanhive's automated system, from all entries with both the correct answers and also the correctly chosen Player of the Match. The automated system will select three (3) names randomly and the first name selected will be the Winner.
        </p>
        <p>
          8.5 The decision of Fanhive is final and no correspondence or discussion will be entered into.
        </p>
        <p>
          8.6 Fanhive will contact the Winner personally as soon as practicable after the Draw Date, using the telephone number or email address provided with the competition entry and will request them to provide bank account details for transfer of the Prize money. 
        </p>
        <p>
          8.7 Fanhive will send an email to all competition Entrants as soon as practicable after the Draw Date, using the email address associated with the Entrants. The email will detail the Prize Winner(s) for the competition they had entered.
        </p>
        <p>
          8.8 Fanhive will archive each competition's winner(s) on the Platform's "Past Winners" page on the Draw Date.  The names of the Winners used on the Past Winners page will be their username for the Platform as set out in the Winners' profile (in accordance with the Privacy Policy set out on the Privacy Policy page of Our Platform).
        </p>
        <p>
          <b>9.</b> The prize
        </p>
        <p>
          9.1 The prize for each competition is set out in the Particulars for that competition on the “Competition Particulars” page on the Platform and is always a monetary prize.
        </p>
        <p>
          9.2 The prize money will be transferred directly to a Winner's bank account upon Fanhive's receipt of their banking details.
        </p>
        <p>
          9.3 The Prize may be supplied by a sponsor of Club Host; any such sponsorship will be clearly specified on the Particulars page for any competition on the Platform.  
        </p>
        <p>
          9.4 The Prize is not negotiable or transferable.
        </p>
        <p>
          <b>10.</b> Claiming the Prizes
        </p>
        <p>
          10.1 Fanhive will contact the Winner directly in order to facilitate Prize payments.
        </p>
        <p>
          10.2 The cash Prizes will be paid into the Winner's bank account by Fanhive.
        </p>
        <p>
          10.3 If you object to your username as a winning entry being published or made available on the Platform, please contact Fanhive on support@fanhive.co.uk . In such circumstances, Fanhive must still provide the information and winning entry to the Advertising Standards Authority on request. 
        </p>
        <p>
          10.4 The Prize may not be claimed by a third party on your behalf.
        </p>
        <p>
          10.5 Fanhive will make all reasonable efforts to contact the Winner and pay the Prize into the Winner's bank account. If the Winner cannot be contacted or is not available, or has not claimed their Prize within 21 days of the Draw Date, Fanhive reserves the right to offer the Prize to the next eligible Entrant selected randomly from the correct entries that were received before the Closing Date.  If the second Winner cannot be contacted or is not available, Fanhive reserves the right to offer the Prize to the third eligible Entrant selected randomly from the correct entries that were received before the Closing Date.  If the third Winner cannot be contacted, then Fanhive reserves the right to pay the Prize money to a charity.
        </p>
        <p>
          10.6 Fanhive does not accept any responsibility if a Winner is not able to take up a Prize.
        </p>
        <p>
          10.7 Fanhive's decision is final and legally binding on all parties and no correspondence or discussion will be entered into.
        </p>
        <p>
          <b>11.</b> Limitation of liability
        </p>
        <p>
          Insofar as is permitted by law, Fanhive, its agents or distributors do not owe you, the Entrant or Winner, any duty of care and will not in any circumstances be responsible or liable to compensate the Winner or accept any liability for any loss, damage, personal injury or death occurring as a result of taking up the Prize except where it is caused by the negligence of Fanhive, its agents or distributors or that of their employees. Your statutory rights are not affected.
        </p>
        <p>
          <b>12.</b> Profile
        </p>
        <p>
          12.1 Users are responsible for their own profiles.
        </p>
        <p>
          12.2 Each User warrants that their profile does not infringe any laws or regulations nor any third party's rights, including but not limited to, the infringement of intellectual property rights such as trademarks.
        </p>
        <p>
          12.3 Each User agrees to indemnify and hold Fanhive harmless in relation to any infringement that a User commits.
        </p>
        <p>
          12.4 Each User may amend their contact information on the profile.
        </p>
        <p>
          <b>13.</b> Ownership of competition entries and intellectual property rights
        </p>
        <p>
          13.1 All competition entries and any accompanying material submitted to Fanhive will become the property of Fanhive on receipt and will not be returned.
        </p>
        <p>
          13.2 By submitting your competition entry and any accompanying material, you agree to:
        </p>
        <p class="indent"><b>13.2.1</b> assign to Fanhive all your intellectual property rights in the entry with full title guarantee; and</p>
        <p class="indent"><b>13.2.2</b> waive all moral rights,</p>
        <p class="indent"> in and to your competition entry and otherwise arising in connection with your entry to which you may now or at any time in the future be entitled under the Copyright, Designs and Patents Act 1988 as amended from time to time and under all similar legislation from time to time in force anywhere in the world.</p>
        <p>
          <b>14.</b> Data protection and publicity
        </p>
        <p>
          Fanhive will only process your personal information as set out in the Privacy Policy. See also condition 8.8 and condition 10.3, with regard to the announcement of Winners and 16.4 relating to promotion.  If you would rather not to any of these things, then please contact Fanhive at support@fanhive.co.uk .
        </p>
        <p>
          <b>15.</b> Unacceptable Behaviour
        </p>
        <p>
          15.1 All participants (Club Hosts, Entrants and Winners) must in relation to any competition refrain from unacceptable behaviour.
        </p>
        <p>
          15.2 Unacceptable behaviour includes, but is not limited to:
        </p>
        <p class="indent"><b>15.2.1</b> behaviour likely to affect the enjoyment of other participants (Club Hosts, Entrants and Winners);</p>
        <p class="indent"><b>15.2.2</b> the use of threatening, abusive or insulting words or behaviour towards other participants (Club Hosts, Entrants and/or Winners) or Fanhive staff;</p>
        <p class="indent"><b>15.2.3</b> acting in a way that can cause or is likely to cause damage, nuisance or injury towards Fanhive and other participants (Club Hosts, Entrants and/or Winners) and their property;</p>
        <p class="indent"><b>15.2.4</b> cyber bullying, harassment or acting in an intimidating or threatening nature.</p>
        <p>
          15.3 Any unacceptable behaviour by any participants (Club Hosts, Entrants and/or Winners) will entitle Fanhive (at its sole discretion) to forfeit any rights such participant (whether they are a Club Host, Entrant and/or Winner) may have accrued pursuant to the Terms and Conditions and/or any competition that they are participating in (whether as a Club Host, Entrant and/or Winner).
        </p>
        <p>
          15.4 Fanhive reserves the right to remove any content on and/or user of Our Platform without providing an explanation.
        </p>
        <p>
          15.5 Fanhive's decision in relation to unacceptable behaviour is final and legally binding on all parties and no correspondence or discussion will be entered into.
        </p>
        <p>
          <b>16.</b> General
        </p>
        <p>
          16.1 If there is any reason to believe that there has been a breach of these Terms and Conditions, Fanhive may, in its sole discretion, reserve the right to exclude you from participating in any current or future competitions and in addition Fanhive may at its sole discretion ban you from using the Platform.
        </p>
        <p>
          16.2 Fanhive reserves the right to hold void, suspend, cancel, or amend any competition where it becomes necessary to do so.
        </p>
        <p>
          16.3 If Fanhive so requests, and you have not previously registered your desire not to do so, the Winners shall render all services in connection with publicity concerning both the Competition (including the Club Host and where relevant its sponsor) and Fanhive (and where relevant its sponsor) as, when, and where reasonably requested by Fanhive (during the competition and after Completion of the competition), including without limitation engaging in interviews and promotional recordings for social media, press outlets and television programmes, making publicity-related posts on the Winner's social media platform(s) at the direction of Fanhive.
        </p>
        <p>
          16.4 Each Winner agrees that Fanhive may use their name, picture, or likeness for any advertising, publicity or other business purpose at any time for a period of two (2) years after the Competition End Date. The use of the Winner's name, picture, or likeness shall not be deemed to result in any invasion of the Winner's privacy, or in violation of any property right the Winner may have; and the Winner shall receive no additional consideration if their name, picture or likeness is so used. The Winner further agrees that any negatives, prints or other material for printing or reproduction purposes prepared in connection with the use of their name, picture or likeness by Fanhive, shall be and are the sole property of Fanhive.
        </p>
        <p>
          <b>17.</b> Service Level and Interruption
        </p>
        <p>
          17.1 You accept that on occasion there may be interruptions to our Platform for scheduled maintenance or upgrades, or emergency repairs, or due to failure of telecommunication services and equipment which are beyond Fanhive's control.
        </p>
        <p>
          17.2 Fanhive will use reasonable efforts to ensure that our Platform remains available for you to access and use in accordance with these Terms and Conditions. However, you acknowledge that Fanhive does not guarantee that our Platform will be available at all times, or be error or interruption free.
        </p>
        <p>
          <b>18.</b> No Promotion
        </p>
        <p>
          The competitions are in no way sponsored, endorsed or administered by, or associated with, Apple Inc. Google, Facebook, Twitter, Snapchat, TikTok and/or any other social network.
        </p>
        <p>
          <b>19.</b> General
        </p>
        <p>
          19.1 If there is any reason to believe that there has been a breach of these Terms and Conditions, Fanhive may, in its sole discretion, reserve the right to exclude you from participating in the competition.
        </p>
        <p>
          19.2 Fanhive reserves the right to hold void, suspend, cancel, or amend the prize competition where it becomes necessary to do so.
        </p>
        <p>
          19.3 These Terms and Conditions shall be governed by English law, and the parties submit to the non-exclusive jurisdiction of the courts of England and Wales.
        </p>
        <p>
          <b>20.</b> Definitions
        </p>
        <p>
          <b>"Closing Date"</b> the date on which any relevant competition ends as set out on the Particulars or, if applicable, whenever the last ticket is sold – whichever is sooner;
        </p>
        <p>
          <b>"Closing Time"</b> the time on which any relevant competition ends as set out in the Particulars or whenever last ticket is sold – whichever is sooner;
        </p>
        <p>
          <b>"Club Host"</b> a sport club user of Our Platform who creates a competition and offers a Prize. (Where two or more Sport Clubs are jointly the Club Host their obligations can be enforced against them jointly or against each of them separately);
        </p>
        <p>
          <b>"Competition Entry Question(s)"</b> the competition's entry question(s) which apply to the relevant competition, as devised by Fanhive;
        </p>
        <p>
          <b>"Draw Date"</b> the day on which the competition Winners are drawn and announced;
        </p>
        <p>
          <b>"Entrant"</b> a User of Fanhive who enters into a competition on the Platform;
        </p>
        <p>
          <b>"Entry Price"</b> the price paid for an entry by an Entrant;
        </p>
        <p>
          <b>"Fanhive"</b> Fanhive Limited is a company incorporated in England and Wales with company registration number 13781356 and registered address at 1 Sundorne Avenue, Shrewsbury, SY1 4JW, United Kingdom;
        </p>
        <p>
          <b>"Opening Date"</b> the date on which any competition is launched on the Platform;
        </p>
        <p>
          <b>"Opening Time"</b> the time at which any competition is launched on the Platform;
        </p>
        <p>
          <b>"Our Platform"</b> our website and any other application or platform that Fanhive operates from time to time;
        </p>
        <p>
          <b>"Particulars"</b> the section of Our Platform relating to the relevant competition that contains a description of the competition and each Prize;
        </p>
        <p>
          <b>"Prize"</b> the monetary prize(s) listed as a prize in the relevant competition Particulars as offered by the Club Host of the competition based on a % of the Entry Proceeds received and, where relevant, any sponsor monies;
        </p>
        <p>
          <b>"Users"</b> an individual registered with Our Platform;
        </p>
        <p>
          <b>"We" (and "Us" and "Our")</b> Fanhive;
        </p>
        <p>
          <b>"Winner"</b> the person who wins the Prize;
        </p>
        <p>
          <b>"You" (and "your")</b> you in your capacity as a user of Our Platform whether as an Entrant or Winner.
        </p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';

export default {
  name: 'termsandconditions',
  components: {
    PageHeader
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn;
    },
  },
  created () {
    
  }
}
</script>